import { withInstall } from '../../../../utils/with-install'
import GLCustom from './GLCustom.vue'

export const ElAmapLayerGlCustom = withInstall(GLCustom)
export default ElAmapLayerGlCustom
